// extracted by mini-css-extract-plugin
module.exports = {"inputToggle":"InputToggle__inputToggle__2iely","enabled":"InputToggle__enabled__7DTdP"};